import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private breakpointObserver = inject(BreakpointObserver);

  public phone$ = this.breakpointObserver
    .observe([Breakpoints.XSmall])
    .pipe(map((result) => result.matches));
  public responsive$ = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
    .pipe(map((result) => result.matches));

  public handset$ = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(map((result) => result.matches));
  public medium$ = this.breakpointObserver
    .observe([Breakpoints.Medium])
    .pipe(map((result) => result.matches));

  public desktop$ = this.responsive$.pipe(map((resp) => !resp));
  public xLarge$ = this.breakpointObserver
    .observe([Breakpoints.XLarge])
    .pipe(map((result) => result.matches));

  isBigScreen = signal(this.breakpointObserver.isMatched('(min-width: 1500px)'));
  phone = toSignal(this.phone$);
  handset = toSignal(this.handset$);
  medium = toSignal(this.medium$);
  responsive = toSignal(this.responsive$);
  desktop = toSignal(this.desktop$);
  xLarge = toSignal(this.xLarge$);
}
